import React from 'react'
import { inject, observer } from 'mobx-react'
import { Button } from 'antd'
import AuthorizedPhonesPopup from '@components/Popup/AuthorizedPhonesPopup'
import EditRoles from '@components/EditRoles'
import CheckMonthlyCommission from './components/MonthlyCommission'
import PaymentPopup from '@components/Popup/PaymentPopup'
import TopAgent from './components/TopAgent'
import UpdateCollectiveStatus from '../UpdateCollectiveStatus'
import UpdateMentor from './components/UpdateMentor'
import AgentMeetings from './components/AgentMeetings'
import ViewCode from '@pages/Clients/ViewCode'
import moment from 'moment'
import EditAgentInfo from './components/EditAgentInfo'
import PortfolioManager from './components/PortfolioManager'
import CollectiveCheckbox from './components/CollectiveCheckbox'
import { isCoordinatorOnly } from '@utils/roles'

@inject((stores: any) => {
    const { authStore, popupStore } = stores
    return { authStore, popupStore }
})
@observer
class AgentTopSection extends React.Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const { agentInfo = {}, authStore, popupStore, updateInfo, getAuthorizedPhones, authorizedPhones } = this.props
        const roles = (authStore && authStore.roles) || []
        if (isCoordinatorOnly(roles)) {
            return (
                <div style={{ ...style.wrapper }} className="agent-top-section">
                    <div style={{ ...style.line }}>
                        <div style={style.cell}>
                            <span>
                                <strong>ת.ז: </strong>
                                {agentInfo.identity ? agentInfo.identity : ''}
                            </span>
                        </div>

                        <div style={style.cell}>
                            <span>
                                <strong>טלפון: </strong>
                                {agentInfo.phone ? '0' + agentInfo.phone : ''}
                            </span>
                        </div>

                        <div style={style.cell}>
                            <span>
                                <strong>אימייל: </strong>
                                {agentInfo.email ? agentInfo.email : ''}
                            </span>
                        </div>

                        <div style={agentInfo.parent_agency_id ? style.cell : {}}>
                            <span>
                                <strong>נוצר בתאריך: </strong>
                                {agentInfo.created_at ? moment(agentInfo.created_at).format('DD/MM/YYYY') : ''}
                            </span>
                        </div>

                        {agentInfo.parent_agency_id && (
                            <div>
                                <span>
                                    <strong>סוכן משנה של: </strong>
                                    <a
                                        target="_blank"
                                        style={{ textDecoration: 'underline', color: 'black' }}
                                        href={`/agents/${agentInfo.parent_agency_id}`}
                                    >
                                        {agentInfo.parent_agency_id}
                                    </a>
                                </span>
                            </div>
                        )}
                    </div>
                    <div className="button-agent-top-section" style={{ ...style.line }}>
                        <div style={{ marginLeft: '0px' }}>
                            <UpdateMentor agentInfo={agentInfo} updateInfo={updateInfo} roles={roles} />
                        </div>
                        <div style={{ marginLeft: '0px' }}>
                            <AgentMeetings agentInfo={agentInfo} updateInfo={updateInfo} />
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <div style={{ ...style.wrapper }} className="agent-top-section">
                <div style={{ ...style.line }}>
                    <div style={style.cell}>
                        <span>
                            <strong>ת.ז: </strong>
                            {agentInfo.identity ? agentInfo.identity : ''}
                        </span>
                    </div>

                    <div style={style.cell}>
                        <span>
                            <strong>טלפון: </strong>
                            {agentInfo.phone ? '0' + agentInfo.phone : ''}
                        </span>
                    </div>

                    <div style={style.cell}>
                        <span>
                            <strong>אימייל: </strong>
                            {agentInfo.email ? agentInfo.email : ''}
                        </span>
                    </div>

                    <div style={agentInfo.agency ? style.cell : {}}>
                        <span>
                            <strong>נוצר בתאריך: </strong>
                            {agentInfo.created_at ? moment(agentInfo.created_at).format('DD/MM/YYYY') : ''}
                        </span>
                    </div>
                    {agentInfo.agency && (roles.includes('admin') || roles.includes('money')) && (
                        <div style={style.cell}>
                            <span>
                                <strong>סוכנות: </strong>
                                {agentInfo.agency.name}
                            </span>
                        </div>
                    )}

                    {agentInfo.agency && (roles.includes('admin') || roles.includes('money')) && (
                        <div style={agentInfo.parent_agency_id ? style.cell : {}}>
                            <span>
                                <strong>ח.פ: </strong>
                                {agentInfo.agency.license}
                            </span>
                        </div>
                    )}
                    {agentInfo.parent_agency_id && (
                        <div>
                            <span>
                                <strong>סוכן משנה של: </strong>
                                <a
                                    target="_blank"
                                    style={{ textDecoration: 'underline', color: 'black' }}
                                    href={`/agents/${agentInfo.parent_agency_id}`}
                                >
                                    {agentInfo.parent_agency_id}
                                </a>
                            </span>
                        </div>
                    )}
                </div>

                <div className="button-agent-top-section" style={{ ...style.line }}>
                    <div style={{}}>
                        {agentInfo.phone && !roles.includes('viewer') && <ViewCode phone={agentInfo.phone} />}
                    </div>

                    <div style={{}}>
                        <Button
                            onClick={() => {
                                popupStore.togglePopup('paymentPopup')
                            }}
                            style={{ marginLeft: '0px' }}
                        >
                            {'תשלום עמלות'}
                        </Button>
                        {popupStore.popupType === 'paymentPopup' ? <PaymentPopup agentInfo={agentInfo} /> : null}
                    </div>

                    <div>
                        <AuthorizedPhonesPopup
                            getAuthorizedPhones={getAuthorizedPhones}
                            user_id={agentInfo.id}
                            list={authorizedPhones}
                        />
                    </div>

                    <div style={{ marginLeft: '0px' }}>
                        <UpdateMentor agentInfo={agentInfo} updateInfo={updateInfo} roles={roles} />
                    </div>

                    <div style={{ marginLeft: '0px' }}>
                        <CheckMonthlyCommission agentInfo={agentInfo} roles={roles} updateInfo={updateInfo} />
                    </div>

                    {(roles.includes('admin') || roles.includes('moderator') || roles.includes('developer')) && (
                        <div style={{ marginLeft: '0px' }}>
                            <TopAgent agentInfo={agentInfo} agentId={agentInfo.id} />
                        </div>
                    )}
                    <div style={{ marginLeft: '0px' }}>
                        <PortfolioManager agentInfo={agentInfo} agentId={agentInfo.id} />
                    </div>
                    <div style={{ marginLeft: '0px' }}>
                        <CollectiveCheckbox
                            agentInfo={agentInfo}
                            agentId={agentInfo.id}
                            updateInfo={updateInfo}
                            canEdit={roles.includes('admin') || roles.includes('money')}
                        />
                    </div>
                    {((roles.includes('money') && agentInfo.is_collective) || roles.includes('admin')) && (
                        <div style={{ marginLeft: '0px' }}>
                            <EditAgentInfo clientInfo={agentInfo} updateInfo={updateInfo} roles={roles} />
                        </div>
                    )}

                    {roles.includes('admin') && (
                        <div style={{ marginLeft: '0px', overflowY: 'visible', maxHeight: '44px' }}>
                            <EditRoles userId={agentInfo.id} userRoles={agentInfo.roles} />
                        </div>
                    )}

                    <div>
                        {agentInfo.roles && agentInfo.roles.includes('collective') && (
                            <UpdateCollectiveStatus agentInfo={agentInfo} updateInfo={updateInfo} />
                        )}
                    </div>

                    <div style={{ marginLeft: '0px' }}>
                        <AgentMeetings agentInfo={agentInfo} updateInfo={updateInfo} />
                    </div>
                </div>
            </div>
        )
    }
}

const style = {
    wrapper: {
        display: 'flex',
        flexDirection: 'column' as 'column',
        alignItems: 'center',
        fontSize: '16px',
        paddingRight: '4px',
        marginBottom: '10px',
        gap: '15px'
    },
    line: {
        display: 'flex',
        flexDirection: 'row' as 'row',
        alignItems: 'center',
        gap: '14px',
        width: '100%',
        flexWrap: 'wrap' as 'wrap'
    },
    cell: { borderLeft: 'solid 1px', paddingLeft: '20px' }
}

export default AgentTopSection
